import { render, staticRenderFns } from "./PowerSwitch.vue?vue&type=template&id=5574aac2&"
import script from "./PowerSwitch.vue?vue&type=script&lang=js&"
export * from "./PowerSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports